// extracted by mini-css-extract-plugin
module.exports = {"box":"View_box_irYA8","banneritem":"View_banneritem_1nyvQ"};